import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/default-layout-narrow.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Digital Marketing Consultant`}</h2>
    <p>{`Tattle is a community of researchers, engineers, and artists working together to improve the information ecosystem in India.
We build tools and datasets to tackle harms such as misinformation and deepfakes, and in the process, enable transparent research on misinformation on Indian Social Media.`}</p>
    <p>{`As a digital marketing consultant for us, you will have the opportunity to work in a private tech company which operates in the social impact sector, and get a sense of the velocity of work and its manner of operations.`}</p>
    <h2>{`About the Role:`}</h2>
    <p>{`We are looking for assistance in performing the following responsibilities for Tattle`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Building and driving engagement for our projects: `}<a parentName="p" {...{
            "href": "https://uli.tattle.co.in/"
          }}>{`Uli`}</a>{`, `}<a parentName="p" {...{
            "href": "https://tattle.co.in/products/feluda/"
          }}>{`Feluda`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Collating and assessing feedback from outreach`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Support in managing partnerships with media outlets, organisations and other individuals`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Engage with the Tattle team and your manager during scheduled online meetings `}</p>
      </li>
    </ul>
    <p>{`The role is fully remote. `}</p>
    <p>{`We are open to and may consider longer engagements with creative and driven individuals.`}</p>
    <h2>{`Experience:`}</h2>
    <p>{`0-1 years.
Candidates in their final year of college may also apply.`}</p>
    <h2>{`Remuneration:`}</h2>
    <p>{`INR 10K per month`}</p>
    <h2>{`Commitment:`}</h2>
    <p>{`Part-time, atleast 5 hours a week`}</p>
    <h2>{`Deadline: 30 May, 2024`}</h2>
    <h2>{`We Value Diversity and Multiplicity of Experiences`}</h2>
    <p>{`To this end, we strongly encourage candidates, even if they feel they don't meet all the above listed criteria but find alignment with the project and are driven to learn, to apply.`}</p>
    <h2>{`Apply `}<a parentName="h2" {...{
        "href": "https://forms.gle/YAJb6knTcyHDCWyS7"
      }}>{`here`}</a></h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      